import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    {
      "PVID": 1,
      "allowVlan": "1-3,11,111,1111",
      "assignedPort": [],
      "ddpState": true,
      "deviceCategory": "ap",
      "id": "0352682d-cda9-4927-80e0-946c536aaaaa",
      "lbdState": true,
      "name": "AP-Profile-A",
      "poeState": true,
      "portState": true,
      "portTags": [],
      "portType": "access",
      "sfpSpeed": "auto",
      "speed": "auto",
      "version": 10
    },
    {
      "PVID": 2,
      "allowVlan": "2-4,22,222,2222",
      "assignedPort": [],
      "ddpState": true,
      "deviceCategory": "ap",
      "id": "0352682d-cda9-4927-80e0-946c536bbbbb",
      "lbdState": true,
      "name": "AP-Profile-B",
      "poeState": true,
      "portState": true,
      "portTags": [],
      "portType": "access",
      "sfpSpeed": "auto",
      "speed": "auto",
      "version": 10
    },
    {
      "PVID": 1,
      "allowVlan": "1-3,11,111",
      "assignedPort": [],
      "ddpState": true,
      "deviceCategory": "switch",
      "id": "0352682d-cda9-4927-80e0-946c536ccccc",
      "lbdState": true,
      "name": "SW-Profile-A",
      "poeState": true,
      "portState": true,
      "portTags": [],
      "portType": "access",
      "sfpSpeed": "auto",
      "speed": "auto",
      "version": 10
    },
    {
      "PVID": 2,
      "allowVlan": "2-4,22,222",
      "assignedPort": [],
      "ddpState": true,
      "deviceCategory": "switch",
      "id": "0352682d-cda9-4927-80e0-946c536ddddd",
      "lbdState": true,
      "name": "SW-Profile-B",
      "poeState": true,
      "portState": true,
      "portTags": [],
      "portType": "access",
      "sfpSpeed": "auto",
      "speed": "auto",
      "version": 10
    },
  ],
};

export const profilesSlices = createSlice({
  name: "profilesPort",
  initialState,
  reducers: {
  },
});

export default profilesSlices.reducer;
